import React, { useState } from "react"
import axios from "@/modules/shared/AxiosInterceptor"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTrash } from "@fortawesome/free-solid-svg-icons"

import { useTranslation } from "react-i18next"
import { PickupDetailsType } from "@/types/createSingleOrder.types"
import {
  openStoreDeletedSuccess,
  openStoreError,
} from "@/UI/Notifications/NotificationsWrappers.component"
import { useSetRecoilState } from "recoil"
import { userAtom } from "@/atoms/userAtom"
import ConfirmModal from "@/UI/Modals/ConfirmModal"

interface DeleteLocationModalProps {
  store: PickupDetailsType
}

const DeleteLocationModal: React.FC<DeleteLocationModalProps> = ({ store }) => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const setUser = useSetRecoilState(userAtom)

  const deleteStore = async () => {
    try {
      setIsLoading(true)
      await axios.delete(`orgs/stores/${store.id}`)
      openStoreDeletedSuccess(t)
      window.localStorage?.setItem("previousSelectedStoreId", "")
      setUser((state) => {
        const newStoreList = state?.stores?.filter((existingStore) => existingStore.id !== store.id)
        return { ...state, stores: newStoreList }
      })
    } catch (error) {
      openStoreError(t)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <ConfirmModal
        disabled={isLoading}
        button={
          <span className="flex items-center rounded-full bg-gray-200 w-8 h-8 cursor-pointer">
            <FontAwesomeIcon className="text-gray-400 mx-auto" icon={faTrash} />
          </span>
        }
        content={{
          title: t("profile.DeleteStoreModal.deleteStore"),
          type: "danger",
          description: t("profile.DeleteStoreModal.confirmation"),
          cancelText: t("common.cancel"),
          okText: t("common.delete"),
        }}
        onConfirm={deleteStore}
      />
    </>
  )
}

export default DeleteLocationModal
